import { HoverDisplay } from '@/components/HoverDisplay';
import { Box, Card, Stack } from '@mantine/core';
import { ReactNode } from 'react';

interface TimelineCardProps {
  header: ReactNode;
  children: ReactNode;
}

export function TimelineCard({ header, children }: TimelineCardProps) {
  return (
    <HoverDisplay>
      <Card withBorder padding={0} radius="lg" style={{ backgroundColor: '#ffffff' }} w="100%">
        <Stack gap={0}>
          <Box
            p="xs"
            style={{
              borderBottom: '1px solid #e9ecef',
            }}
          >
            {header}
          </Box>

          {/* Content */}
          {children && <Box p="lg">{children}</Box>}
        </Stack>
      </Card>
    </HoverDisplay>
  );
}
